import { MenuItemType, menuItemSchema, menuItemsSchema } from "../schemas/menu";
import RESTService from "./rest_service";

export default abstract class MenuService {
	public static async getMenu(): Promise<MenuItemType[]> {
		const requestedData = await RESTService.get(
			`/bitrix/services/main/ajax.php?action=module%3Aproject.iblock.menu`
		);
		if (requestedData instanceof Array) {
			const menuItems: MenuItemType[] = [];
			(requestedData as Array<any>).forEach((menuItem: any) => {
				const parsed = menuItemSchema.safeParse(menuItem);
				if (parsed.success) menuItems.push(parsed.data);
				else
					console.log(
						(menuItem?.id
							? "History event id: " + menuItem.id + "\n\n"
							: "") + parsed.error
					);
			});
			return menuItems;
		}
		return [];
	}
}
